function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd"
}, React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M5.756 14.036l2.101 2.14c-2.173 2.135-3.623 4.401-4.303 6.721l-.101.367-2.906-.748c.776-3.013 2.552-5.872 5.209-8.48zM23.576 4.241l.902 2.861c-5.329 1.682-9.916 3.879-13.464 6.436l-.438.322-1.796-2.403c3.894-2.91 8.94-5.368 14.796-7.216zM47.825.5l.054 3c-6.79.122-13.336.962-19.288 2.445l-.846.216-.76-2.902C33.395 1.581 40.477.632 47.825.5zM92.67 14.036l-2.101 2.14c2.173 2.135 3.624 4.401 4.303 6.721l.101.367 2.906-.748c-.776-3.013-2.552-5.872-5.209-8.48zM74.85 4.241l-.902 2.861c5.329 1.682 9.916 3.879 13.464 6.436l.438.322 1.796-2.403c-3.893-2.91-8.94-5.368-14.796-7.216zM50.601.5l-.054 3c6.79.122 13.336.962 19.288 2.445l.846.216.76-2.902C65.031 1.581 57.95.632 50.601.5zM5.756 37.964l2.101-2.14c-2.173-2.135-3.623-4.401-4.303-6.721l-.101-.367-2.906.748c.776 3.013 2.552 5.872 5.209 8.48zM23.576 47.759l.902-2.861c-5.329-1.682-9.916-3.879-13.464-6.436l-.438-.322-1.796 2.403c3.894 2.91 8.94 5.368 14.796 7.216zM47.825 51.5l.054-3c-6.79-.122-13.336-.962-19.288-2.445l-.846-.216-.76 2.902c6.41 1.678 13.492 2.627 20.84 2.759zM92.67 37.964l-2.101-2.14c2.173-2.135 3.624-4.401 4.303-6.721l.101-.367 2.906.748c-.776 3.013-2.552 5.872-5.209 8.48zM74.85 47.759l-.902-2.861c5.329-1.682 9.916-3.879 13.464-6.436l.438-.322 1.796 2.403c-3.893 2.91-8.94 5.368-14.796 7.216zM50.601 51.5l-.054-3c6.79-.122 13.336-.962 19.288-2.445l.846-.216.76 2.902c-6.41 1.678-13.492 2.627-20.84 2.759z"
})), React.createElement("path", {
  d: "M36.927 24.504c.992-1.544 2.25-2.448 5.124-3.474-5.486-4.744-7.34-6.324-14.003-12.173-11.485 3.264-19.33 9.02-20.049 15.647h28.928zM57.47 30.45c4.38 3.707 9.262 8.068 13.687 11.884 11.265-3.066 19.178-8.5 20.57-14.83H61.18c-.667.999-1.516 1.917-3.71 2.946z"
}));

const SvgMd1 = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: 98,
  height: 52,
  viewBox: "0 0 98 52",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgMd1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/md1.1ffb5f6c.svg";
export { ForwardRef as ReactComponent };